// @ts-nocheck
import React, { useCallback } from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { ReactComponent as CodeIcon } from '../../../../../assets/Icons/lucideIcons/code.svg';
import { ReactComponent as TextFieldsIcon } from '../../../../../assets/Icons/lucideIcons/type.svg';
import { Tooltip } from '@mui/material';

import {
  useTableDispatch,
  useTableState,
} from '../../../context/TableSchemaBuilderContext';
import GroupWrapper from '../Wrappers/GroupWrapper';

const ValueTypeGroup = () => {
  const { ui, schema } = useTableState();
  const dispatch = useTableDispatch();

  const handleValueTypeChange = useCallback(
    (_event, newType) => {
      if (!newType || !ui?.currentCell) {
        return;
      }

      dispatch({
        type: 'UPDATE_CELL_VALUE_TYPE',
        payload: {
          cellId: ui?.currentCell,
          valueType: newType,
        },
      });
    },
    [dispatch, ui?.currentCell, dispatch]
  );

  return (
    <GroupWrapper label="Value Type">
      <ToggleButtonGroup
        size="small"
        exclusive
        value={schema?.cells?.[ui?.currentCell]?.valueType || 'default'}
        onChange={handleValueTypeChange}
        sx={{ mx: 1 }}
      >
        <Tooltip title="Default">
          <ToggleButton value="default">
            <TextFieldsIcon width={18} height={18} />
          </ToggleButton>
        </Tooltip>
        <Tooltip title="Formula">
          <ToggleButton value="formula">
            <CodeIcon width={18} height={18} />
          </ToggleButton>
        </Tooltip>
      </ToggleButtonGroup>
    </GroupWrapper>
  );
};

export default ValueTypeGroup;
